import { useAddInConfig } from '@/_shared/hooks/add-in-config.js';
import { Body1, Spinner } from '@fluentui/react-components';
import { Navigate } from '@tanstack/react-router';
import { claimReportByTenant } from '@this/shared/dist/data/claim-report.js';
import { tenantDetails } from '@this/shared/dist/data/tenant.js';
import { useStyles } from './_styles.js';
import { ClaimReportCard } from './card.js';

export function ReportClaim() {
    const styles = useStyles();

    const { data, isPending } = useAddInConfig();

    if (isPending) {
        return (
            <div className={styles.page}>
                <Spinner size="large" label="Lade Schadenmeldung..." />
            </div>
        );
    }

    // Schadenmanager users can still reach this route by deep link; their home
    // is the Schadenmanager, and their config carries no tenant.
    if (data && data.body.access !== 'claim-report') {
        return <Navigate to="/" replace />;
    }

    // The channels themselves are static; only the tenant they belong to comes
    // from the backend, so without it there is nothing to offer.
    const tenant = data?.body.tenant;

    if (!tenant) {
        return (
            <div className={styles.page}>
                <Body1>
                    Die Informationen zur Schadenmeldung konnten nicht geladen werden. Bitte versuchen Sie es später
                    erneut.
                </Body1>
            </div>
        );
    }

    return (
        <div className={styles.page}>
            <ClaimReportCard tenantName={tenantDetails[tenant].name} report={claimReportByTenant[tenant]} />
        </div>
    );
}
